import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { AppTokenService } from "../app-token.service";
import { HttpHandlerService } from "../http-handler.service";
import { Observable } from "rxjs";

@Injectable()

export class PickupService {
    _httpHandler: HttpHandlerService;
    _apiUrl = environment.apiUrl;
    _getResourceEndPoint = 'pickups';

    constructor(private httpHandler: HttpHandlerService, private appTokenService: AppTokenService) {
        this._httpHandler = httpHandler;
    }


    public GetAll(params?: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}`
        const request_option = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this.httpHandler.request(request_option, this.appTokenService.tokenizedResponse)
    }

    public GetAllList(params?: any): Observable<any> {
        let full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/list?pagelimit=${params?.length}&pageoffset=${params?.start}`
        if (params?.refresh) {
            full_api_url = full_api_url + `refresh=${new Date().getTime()}`;
        }
        const request_option = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this.httpHandler.request(request_option, this.appTokenService.tokenizedResponse)
    }

    public GetById(userId: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/${userId}`;
        const request_options = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }

    public GetByPickupNo(referenceNo: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/awb/${referenceNo}`;
        const request_options = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }

    public Add(userData: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}`;
        const request_options = this._httpHandler.prepareRequest(
            'POST',
            full_api_url,
            userData
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse)
    }

    public Update(userData: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}`;
        const request_options = this._httpHandler.prepareRequest(
            'PUT',
            full_api_url,
            userData
        );

        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse)
    }

    public Delete(userId: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/${userId}`;
        const request_option = this._httpHandler.prepareRequest('DELETE', full_api_url, {});
        return this._httpHandler.request(request_option, this.appTokenService.tokenizedResponse)
    }

    public TransferPickups(data: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/transfer`;
        const request_option = this._httpHandler.prepareRequest('PUT', full_api_url, data);
        return this._httpHandler.request(request_option, this.appTokenService.tokenizedResponse)
    }

    public AssignPickups(data: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/assign`;
        const request_option = this._httpHandler.prepareRequest('POST', full_api_url, data);
        return this._httpHandler.request(request_option, this.appTokenService.tokenizedResponse)
    }

    
    public getUsersDefaultLocationById(userId: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/location/${userId}`;
        const request_options = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }
}



